import React from "react";
import { useState, useEffect } from "react";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import NewDynamic_PR_table from "../../../components/NewDynamic_PR_Table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";

const PerformanceEvalRepSubjective = () => {
  const [reportList, setReplortList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [appraisalOpts, setAppraisalOpts] = useState([]);
  const [quesOpts, setQuesOpts] = useState([]);
  const [ques, setQue] = useState({});
  const [loading, setLoading] = useState(false);
  const [filterFormData, setFilterData] = useState([]);
  const [apiStatus, setApiStatus] = useState('')
  const dispatch = useDispatch();
  useEffect(() => {
    fetchCycleAndQuestion();
    dispatch(updateNavbarHeading("Performance Evaluation Report (Subjective)"));
  }, []);

  const fetchCycleAndQuestion = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}get-cycles/questions`);

      if (response.status === 200) {

        const Appraisalopts = response?.data?.appraisalCycle?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        Appraisalopts.unshift({ value: "", label: "All" });
        setAppraisalOpts(Appraisalopts);
        const queopts = response?.data?.question?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setQuesOpts(queopts);

        setQue(queopts[0]);
        fetchReportList("", queopts[0].value);
      }
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  useEffect(() => {
    if (quesOpts.length > 0 && quesOpts[0]?.value) {
      setFilterData((prevData) => [
        { label: "Question", value: quesOpts[0]?.value },
        { label: "Appraisal Cycle", value: "" },
      ]);
    }
  }, [quesOpts]);

  const fetchReportList = async (appCycleID, QueID) => {
    setApiStatus(undefined)

    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/5?P_AppraisalCycleID=${appCycleID}&P_ID=${QueID}`
      );
      setApiStatus(response?.status)

      if (response?.status == 200) {
        setReplortList(response?.data?.header);
      }
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  const columns = {
    EmployeeName: { text: "Employee", visible: true },
    Reviewer: { text: "Manager", visible: true },
    EmployeeAnswer: { text: "Employee Response", visible: true },
    Title: { text: "Reviewer Response" },
    QuestionType_202: { text: "Emp. Rating", align: "center" },
    QuestionMasterID: { text: "Rev. Rating", align: "center" },
  };

  const defaultColumns = {
    EmployeeName: true,
    Reviewer: true,
    EmployeeAnswer: true,
    Title: true,
    QuestionType_202: true,
    QuestionMasterID: true,
  };

  const formDatas = [
    {
      name: "Appraisal Cycle",
      type: "Select",
      options: [...appraisalOpts],
    },

    {
      name: "Question",
      type: "Select",
      options: [...quesOpts],
    },
  ];

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}pr-report/5?P_AppraisalCycleID=${filterFormData.find((o) => o.label === "Appraisal Cycle")
          ? filterFormData.find((o) => o.label === "Appraisal Cycle").value
          : 0
        }&P_ID=${filterFormData.find((o) => o.label === "Question")
          ? filterFormData.find((o) => o.label === "Question").value
          : 0
        }`
      );
      setApiStatus(response?.status)
      const cleanedData = response;
      if (response.status === 200) {
        setReplortList(response?.data?.data?.header);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };


  const handleChange = (e, name) => {
    if (name == "Question") {
      setQue(e);
    }
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row d-flex ">
            <div className="col-1  text-start ">
              <h5>Questions:</h5>
            </div>
            <div className="col-10 ms-1  d-flex align-items-center">
              {ques.label}
            </div>
          </div>
          <div className="box-body table-responsive container-fluid">
            <Dynamic_PR_table
              data={reportList}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isActionRequired={false}
              isAddNewBtnRequired={false}
              showIcon1={false}
              showIcon2={false}
              showIcon3={false}
              formDatas={formDatas}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              handleChange={handleChange}
              isFilterRequired={true}
              showIcon4={false}
              showIcon5={false}
              // handleIcon3={handleView}
              // handleAddNew={handleAddNew}
              // handleIcon1={handleEdit}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon3Text: "View",
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PerformanceEvalRepSubjective;
